
<v-row class="no-frame mb-6" v-if="scope">
    <v-col class="no-frame pr-2">
        <v-switch
            v-model = "scope.elevator"
            :label  = "$t('disposition.order.scope.elevator')"
            :ripple = "false"
            class   = "mt-2"
            @change = "onChanged"
            dense
            hide-details
        />
        <v-switch
            v-model = "scope.sticker"
            :label  = "$t('disposition.order.scope.sticker')"
            :ripple = "false"
            @change = "onChanged"
            dense
            hide-details
        />
        <v-switch
            v-model = "scope.lgs"
            :label  = "$t('disposition.order.scope.lgs')"
            :ripple = "false"
            @change = "onChanged"
            dense
            hide-details
        />
    </v-col>

    <v-col class="no-frame pl-2">
        <v-switch
            v-model = "scope.condition"
            :label  = "$t('disposition.order.scope.condition')"
            class   = "mt-2"
            :ripple = "false"
            @change = "onChanged"
            dense
            hide-details
        />
        <v-switch
            v-model = "scope.audit"
            :label  = "$t('disposition.order.scope.audit')"
            :ripple = "false"
            @change = "onChanged"
            dense
            hide-details
        />
        <v-switch
            v-model = "scope.esg"
            :label  = "$t('disposition.order.scope.esg')"
            :ripple = "false"
            @change = "onChanged"
            dense
            hide-details
        />
    </v-col>
</v-row>
